var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown",class:_vm.timeLeft ? 'animation' : '',style:({
    'animation-duration': `${_vm.time}s`,
    '--t': _vm.timeLeft,
  })},[_c('svg',{attrs:{"viewBox":"-50 -50 100 100","stroke-width":"10"}},[_c('circle',{attrs:{"r":"45"}}),_c('circle',{attrs:{"r":"45","pathLength":"1"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }